"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _coachmark = _interopRequireDefault(require("@amzn/meridian-tokens/component/coachmark"));
var _popover = _interopRequireDefault(require("@amzn/meridian-tokens/component/popover"));
var _closeSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/close-small"));
var _popover2 = _interopRequireDefault(require("../popover"));
var _focus = _interopRequireDefault(require("../_focus"));
var _clickable = _interopRequireDefault(require("../_clickable"));
var _button = _interopRequireDefault(require("../button"));
var _icon = _interopRequireDefault(require("../icon"));
var _theme = require("../theme");
var _useElementPosition3 = _interopRequireDefault(require("../_use-element-position"));
var _token = require("./../_utils/token");
var _functional = require("./../_utils/functional");
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _rtl = require("./../_utils/rtl");
var _refObject = _interopRequireDefault(require("./../_prop-types/ref-object"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var orbAnimation = function orbAnimation(startingSize, finalSize) {
  return (0, _css.keyframes)({
    "0%": {
      opacity: 1,
      width: startingSize,
      height: startingSize
    },
    "60%": {
      opacity: 0,
      width: finalSize,
      height: finalSize
    },
    "100%": {
      opacity: 0,
      width: startingSize,
      height: startingSize
    }
  });
};
var wrapperStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var fixed = _ref.fixed,
    zIndex = _ref.zIndex;
  return (0, _css.css)({
    width: t("markerSize"),
    height: t("markerSize"),
    padding: t("markerSpacingInset"),
    position: fixed ? "fixed" : "relative",
    display: "inline-block",
    // HACK: We increase the specificity here to prevent Column/Row from
    // overriding box-sizing styles
    "&[mdn-coachmark-wrapper]": {
      boxSizing: "content-box !important"
    },
    zIndex: zIndex
  });
}, ["fixed", "zIndex"]);
var markerStyles = (0, _functional.memoize)(function (t) {
  return (0, _css.css)({
    width: t("markerSize"),
    height: t("markerSize"),
    borderRadius: t("markerRadius")
  });
});
var clickableStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var focus = _ref2.focus;
  return (0, _css.css)({
    position: "absolute !important",
    top: 0,
    left: 0,
    padding: t("markerSpacingInset"),
    "& > div": {
      transition: t.transitionCss("markerMotion", "background"),
      background: t("markerBackgroundColor", "default")
    },
    ":hover > div": {
      background: t("markerBackgroundColor", "hover")
    },
    ":active > div": {
      background: t("markerBackgroundColor", "pressed")
    }
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: -2,
    borderRadius: t("markerRadius")
  }));
}, ["focus"]);
var orbStyles = (0, _functional.memoize)(function (t) {
  var _t$match = t("orbMotionTiming").match(/(\d+)(\w+)/),
    _t$match2 = (0, _slicedToArray2["default"])(_t$match, 3),
    value = _t$match2[1],
    unit = _t$match2[2];
  // HACK: multiply timing value here in order to achieve delay
  // between animations. Basically, by drawing out the timing here
  // we can add artificial delay in our keyframes in `orbAnimation`
  // by adding keyframes at certain percentages of no actual change
  // which gives the perception of a delay
  var timing = "".concat(value * 1.5).concat(unit);
  return (0, _css.css)({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: t("orbSizeStart"),
    height: t("orbSizeStart"),
    boxSizing: "border-box",
    border: t.borderCss("orbBorder"),
    borderRadius: t("orbBorderRadius"),
    animation: "".concat(orbAnimation(t("orbSizeStart"), t("orbSizeEnd")), " ").concat(timing, " ").concat(t("orbMotionFunction"), " infinite"),
    pointerEvents: "none"
  });
});
var popoverBodyStyles = (0, _functional.memoize)(function (t) {
  return (0, _css.css)({
    display: "flex",
    // HACK: we reverse the row here so button will be the
    // first element in the popover's tab order
    flexDirection: "row-reverse",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "& > button": {
      marginTop: 4 - t("headerSpacingVerticalMedium"),
      marginInlineEnd: 4 - t("headerSpacingHorizontalMedium"),
      marginInlineStart: t("headerSpacingHorizontalSmall")
    }
  });
});
var getFixedStyle = function getFixedStyle(_ref3) {
  var _ref3$left = _ref3.left,
    left = _ref3$left === void 0 ? 0 : _ref3$left,
    _ref3$top = _ref3.top,
    top = _ref3$top === void 0 ? 0 : _ref3$top,
    alignmentHorizontal = _ref3.alignmentHorizontal,
    alignmentVertical = _ref3.alignmentVertical,
    size = _ref3.size,
    _ref3$dir = _ref3.dir,
    dir = _ref3$dir === void 0 ? "ltr" : _ref3$dir;
  // Convert the alignmentHorizontal start/end to be in terms of left/right
  var newAlignmentHorizontal = (0, _rtl.getHorizontalDirection)(alignmentHorizontal);
  var nudgeLeft = newAlignmentHorizontal === "right" && dir === "ltr" || newAlignmentHorizontal === "left" && dir === "rtl" ? size : newAlignmentHorizontal === "right" && dir === "rtl" || newAlignmentHorizontal === "left" && dir === "ltr" ? -size : 0;
  var nudgeTop = alignmentVertical === "top" ? -size : alignmentVertical === "bottom" ? size : 0;
  return {
    left: dir === "rtl" ? left - nudgeLeft : left + nudgeLeft,
    top: top + nudgeTop,
    transform: "translate(-50%,-50%)"
  };
};
function Coachmark(props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    localAnimating = _useState2[0],
    setLocalAnimating = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var markerRef = (0, _react.useRef)();
  var tCoachmark = (0, _theme.useTheme)(_coachmark["default"], "coachmark");
  var tPopover = (0, _theme.useTheme)(_popover["default"], "popover");
  var onClick = props.onClick,
    onClose = props.onClose,
    onOpen = props.onOpen,
    onDismiss = props.onDismiss,
    openOnMount = props.openOnMount;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  // When the orb is pressed
  var handleClick = (0, _react.useCallback)(function () {
    setOpen(true);
    if (onClick) onClick();
  }, [onClick]);
  // When the popover opens
  var handleOpen = (0, _react.useCallback)(function () {
    setLocalAnimating(false);
    if (onOpen) onOpen();
  }, [onOpen]);
  // When the user presses outside the popover
  var handleClose = (0, _react.useCallback)(function () {
    setOpen(false);
    if (onClose) onClose();
  }, [onClose]);
  // When the user presses the close button
  var handleDismiss = (0, _react.useCallback)(function () {
    setLocalAnimating(false);
    setOpen(false);
    if (onDismiss) onDismiss();
    if (onClose) onClose();
  }, [onDismiss, onClose]);
  var markerSize = (0, _react.useMemo)(function () {
    return tCoachmark("markerSize");
  }, [tCoachmark]);
  var dir = props.anchorNode ? (0, _rtl.getDOMDirection)(props.anchorNode.current) : "ltr"; // fallback to LTR for the anchor node direction

  // Set the horizontal alignment in left/right terms (this is necessary
  // for css positioning and offsets).
  // Swap for RTL layouts.
  var leftOrRightAlignmentHorizontal = (0, _rtl.getHorizontalDirection)(dir === "rtl" ? (0, _rtl.getRtl)(props.alignmentHorizontal) : props.alignmentHorizontal);
  var _useElementPosition = (0, _useElementPosition3["default"])({
      elementNode: props.anchorNode,
      originVertical: props.alignmentVertical,
      originHorizontal: leftOrRightAlignmentHorizontal
    }),
    _useElementPosition2 = (0, _slicedToArray2["default"])(_useElementPosition, 3),
    left = _useElementPosition2[0],
    top = _useElementPosition2[1],
    positionReady = _useElementPosition2[2];
  var leftOffset = dir === "rtl" && leftOrRightAlignmentHorizontal === "right" ? -props.offsetHorizontal : props.offsetHorizontal;
  var positionStyle = props.anchorNode ? getFixedStyle({
    left: dir === "rtl" ? left - leftOffset : left + leftOffset,
    top: top + props.offsetVertical,
    alignmentHorizontal: leftOrRightAlignmentHorizontal,
    alignmentVertical: props.alignmentVertical,
    size: markerSize,
    dir: dir
  }) : props.offsetHorizontal > 0 || props.offsetVertical > 0 ? {
    transform: "translateX(".concat(props.offsetHorizontal, "px) translateY(").concat(props.offsetVertical, "px)")
  } : {};
  (0, _react.useEffect)(function () {
    if (openOnMount) {
      setOpen(true);
      setLocalAnimating(false);
    }
    // NOTE: Only run this once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // This variable determines if the coachmark is animating. If the user has
  // defined an override via props, use that. Otherwise, use our local
  // animating variable `localAnimating`
  var animating = props.animating !== undefined ? props.animating : localAnimating;
  return !props.anchorNode || positionReady ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: wrapperStyles(tCoachmark, {
      fixed: props.anchorNode ? true : false,
      zIndex: props.zIndex
    }),
    style: positionStyle,
    "mdn-coachmark-wrapper": ""
  }, animating ? /*#__PURE__*/_react["default"].createElement("span", {
    className: orbStyles(tCoachmark)
  }) : null, /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref4) {
    var focus = _ref4.focus,
      focusTrigger = _ref4.focusTrigger,
      focusProps = _ref4.focusProps;
    return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({
      ref: markerRef,
      className: clickableStyles(tCoachmark, {
        focus: focus && focusTrigger === "keyboard"
      }),
      onClick: handleClick,
      "aria-label": props.label,
      "mdn-popover-offset": -tCoachmark("markerSpacingInset")
    }, focusProps, passThroughProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: markerStyles(tCoachmark)
    }));
  })), /*#__PURE__*/_react["default"].createElement(_popover2["default"], {
    anchorNode: markerRef.current,
    open: open,
    onOpen: handleOpen,
    onClose: handleClose,
    position: props.popoverPosition,
    alignment: props.popoverAlignment,
    minWidth: props.popoverMinWidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: popoverBodyStyles(tPopover)
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    size: "small",
    onClick: handleDismiss
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _closeSmall["default"]
  }, props.popoverDismissLabel)), props.children))) : null;
}
Coachmark.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the popover that will open when the coachmark is pressed.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * This determines which side of the coachmark the popover appears on.
   */
  popoverPosition: _propTypes["default"].oneOf(["top", "end", "bottom", "start"]).isRequired,
  /**
   * If anchorNode is provided, the horizontal point on the anchor node to stick the coachmark.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["start", "end", "center"]),
  /**
   * If anchorNode is provided, the vertical point on the anchor node to stick the coachmark.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "bottom", "center"]),
  /**
   * The node to "stick" the coachmark too. We recommended using React's [useRef](https://reactjs.org/docs/hooks-reference.html#useref) hook
   * to get the the anchorNode.
   *
   * ```
   * const anchorNode = useRef()
   *
   * <React.Fragment>
   *   <Text ref={anchorNode}>
   *     Stick to me
   *   </Text>
   *   <Coachmark
   *     anchorNode={anchorNode}
   *     alignmentHorizontal="center"
   *     alignmentVertical="center"
   *   >
   *     {children}
   *   </Coachmark>
   * </React.Fragment>
   * ```
   */
  anchorNode: _refObject["default"],
  /**
   * Use this prop to override the default animation state. By default, the coachmark
   * will start animating on mount and stop animation on user click.
   */
  animating: _propTypes["default"].bool,
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Coachmark component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-label
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `label` prop details.
   */
  "aria-*": _propTypes["default"].string,
  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,
  /**
   * Move the coachmark horizontally from its original position. Positive
   * numbers will move the coachmark that many pixels to the right, negative
   * numbers to the left.
   */
  offsetHorizontal: _propTypes["default"].number,
  /**
   * Move the coachmark vertically from its original position. Positive
   * numbers will move the coachmark that many pixels down, negative numbers up.
   */
  offsetVertical: _propTypes["default"].number,
  /**
   * If set to true the coachmark will open and shift focus to the popover as soon
   * as it's mounted.
   *
   * Use this sparingly as there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   */
  openOnMount: _propTypes["default"].bool,
  /**
   * This determines how the popover is aligned with the coachmark.
   *
   * Note that only certain values are valid depending on what the "position" prop
   * is set to. If the position is "top" or "bottom" then valid values here
   * are "start", "end", or "center". If the position is "start" or "end"
   * then valid values are "top", "bottom", or "center".
   */
  popoverAlignment: _propTypes["default"].oneOf(["top", "end", "bottom", "start", "center"]),
  /**
   * An accessible label for the popover's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  popoverDismissLabel: _propTypes["default"].string,
  /**
   * Define a minimum width for the popover. Any CSS width value is
   * acceptable.
   */
  popoverMinWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * The stack level of the coachmark along the z-axis. Use this when another
   * element obscures the coachmark. See the [z-axis elevation guide](https://meridian.a2z.com/for-developers/react-web/guides/z-axis-elevation/)
   * for details on working with z-index values in Meridian.
   */
  zIndex: _propTypes["default"].number,
  /**
   * This function will be called when the coachmark is pressed.
   */
  onClick: _propTypes["default"].func,
  /**
   * The popover will call this when it closes. See `onDismiss` to detect when
   * the user presses the popover's dismiss button.
   */
  onClose: _propTypes["default"].func,
  /**
   * This function will be called when the popover's dismiss button is pressed.
   * Useful for differentiating between a user closing the popover by pressing the
   * dismiss button or pressing outside the popover.
   */
  onDismiss: _propTypes["default"].func,
  /**
   * This function will be called when the popover is opened (after the
   * popover has been added to the DOM).
   */
  onOpen: _propTypes["default"].func
} : {};
Coachmark.defaultProps = {
  popoverDismissLabel: "Dismiss",
  offsetHorizontal: 0,
  offsetVertical: 0
};
var _default = Coachmark;
exports["default"] = _default;